
<template lang="pug">
  //- .sud-card
  v-card.sud-card(flat)
    slot
</template>

<script>
export default {
  name: "app-card"
};
</script>

<style scoped>
.sud-card {
  margin-bottom: 8px;
  border-radius: 5px 5px 0px 0px;
}
</style>

   